// AUTOGENERATED FILE
// source: scripts/generate-product-types-templates.ts

import React from 'react'
import { ReactComponent as TemplateSVG } from '../../../../../assets/product-templates/svg/fefco-713-template.svg'

export const Fefco713Template = (props: React.SVGProps<SVGSVGElement>) => {
  return <TemplateSVG {...props} />
}
